import { create } from 'zustand';

type State = {
  lastConnectorId?: string | null;
};

type Actions = {
  updateLastConnectorId: (id: string) => void;
};

const initialState = typeof window !== 'undefined' ? localStorage.getItem('pcm-recent') : undefined;

export const useLastConnectorId = create<State & Actions>((set) => ({
  lastConnectorId: initialState,
  updateLastConnectorId: (value) => {
    const id = value.replace('solana_', '');
    localStorage.setItem('pcm-recent', id);
    set({ lastConnectorId: id });
  },
}));
